<template>
  <el-dialog title="" width="1095px" class="no-header" append-to-body :visible="dialogVisible" :before-close="handleClose">
    <div slot="title" class="dialog-title">
      素材图片查看 <span class="page">{{SwiperThumbIndex + 1}}/{{ imgs.length }}</span>
    </div>
    <div class="image-view">
      <div class="swiper-wraper">
        <swiper ref="swiperTop" class="swiper" :options="swiperOptions" @slideChange="onSlideChange">
          <swiper-slide v-for="(childImage) in imgs" :key="childImage.name">
            <img class="w-full object-contain" :src="childImage.url" />
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" />
          <div class="swiper-button-next" slot="button-next" />
        </swiper>
        <div class="swiper-thumbs" ref="swiperThumbs">
          <div class="swiper-slide" v-for="(childImage, cIndex) in imgs" :key="`swiper__thumb__${cIndex}`"
            @click="handleClickSwiperThumb(cIndex)" :class="{ 'swiper-slide-active': cIndex === SwiperThumbIndex }">
            <img class="w-full h-full object-cover" :src="childImage.url" fit="cover" />
          </div>
        </div>
      </div>
      <div class="image-view-content">
        <div class="name">
          {{ imgInfo.name }}
          <em v-if="!!imgInfo.images_num">({{ imgInfo.images_num }})</em>
        </div>
        <div class="desc">{{ imgInfo.introduction }}</div>
      </div>
      <v-loading :active="loading"></v-loading>
    </div>
  </el-dialog>

</template>

<script>
import { defineComponent, ref, useContext, computed } from '@nuxtjs/composition-api';
export default defineComponent({
  data() {
    return {
      dialogVisible:false,
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 0,
      },
      imgs: [
        {
          name:'xxsifiafjiwjfwf',
          url:'https://static.shangchuanba.com/wiki/resources/202105/52B13FAFDFE7A53872B1F2B59B30CF46.jpeg_1080x1080q100.jpg'
        },
        {
          name:'xxsifiafjiwjfwf23',
          url:'https://static.shangchuanba.com/wiki/resources/202105/F01BCBB18E434B52847135339E1F1C9F.jpeg_1080x1080q100.jpg'
        },
        {
          name:'xxsifiafjiwjfwf121212',
          url:'https://static.shangchuanba.com/wiki/resources/202105/52B13FAFDFE7A53872B1F2B59B30CF46.jpeg_1080x1080q100.jpg'
        },
        {
          name:'xxsifiafjiwjfwafwfwf1212',
          url:'https://static.shangchuanba.com/wiki/resources/202104/9637A022FA127491E93E656FD633C013.jpg_1080x1080q100.jpg'
        },
        {
          name:'xxsifiafjiwjfwffwhufhufhua',
          url:'https://static.shangchuanba.com/wiki/resources/202105/52B13FAFDFE7A53872B1F2B59B30CF46.jpeg_1080x1080q100.jpg'
        },
      ], //图片
      SwiperThumbIndex: 3, //swiper缩率图 索引
      imgInfo: {
        name: "",
      },
      loading: false,
    };
  },
  methods:{
    onSlideChange() {
      const { activeIndex } = this.$refs.swiperTop.$swiper;
      this.SwiperThumbIndex = activeIndex;
      const  {
        name
      } = this.imgs[activeIndex];

      Object.assign(this.imgInfo, {
        name,
      });
      this.onScrollView();
    },
     //切换缩率图样式
     handleClickSwiperThumb(index) {
      this.SwiperThumbIndex = index;
      this.$refs.swiperTop.$swiper.slideTo(index);
    },
    setData(currentUrl,imgPaths){
      this.dialogVisible = true
      
      const index = imgPaths.findIndex(item=>item.url === currentUrl)
      this.SwiperThumbIndex = index
      this.imgInfo.name = imgPaths[index].name
      this.imgs = imgPaths
      this.$nextTick(()=>{
        this.$refs.swiperTop?.$swiper.slideTo(index);
      })
      
    },
    handleClose() {
      this.dialogVisible = false;
    },
    //滚动视图
    onScrollView() {
      if (this.imgs.length <= 4) {
        return false;
      }

      let tempIndex = this.SwiperThumbIndex < 0 ? 0 : this.SwiperThumbIndex - 1;
      this.$refs.swiperThumbs.scrollTop = tempIndex * 130;
    },
  }
})
</script>

<style lang="scss" scoped>
::v-deep .no-header .el-dialog__header, ::v-deep .no-header .el-dialog__body {
  padding: 0;
}
.dialog-title {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  font-weight: 500;
  font-size: 20px;
}
.dialog-title .page {
  color: #595959;
  font-size: 16px;
  padding-left: 12px;
}
.image-view {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 40px;
  padding-right: 40px;
  width: 100%;
}
.image-view .swiper-wraper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  width: 100%;
}
.image-view .swiper-wraper .swiper {
  height: 526px;
  margin: 0px;
  width: 786px;
}
.image-view .swiper-wraper .swiper .swiper-slide {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 526px;
  border-radius: 2px;
  overflow: hidden;
}
.image-view .swiper-wraper .scroll-bar-wrapper {
  margin: 0px;
  width: 198px;
}
.image-view .swiper-wraper .swiper-thumbs {
  height: 528px;
  margin: 0px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 198px;
}
.image-view .swiper-wraper .swiper-thumbs .swiper-slide {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  border-style: solid;
  border-width: 2px;
  cursor: pointer;
  height: 131px;
  width: 100%;
}
.image-view .swiper-wraper .swiper-thumbs .swiper-slide-active {
  --tw-border-opacity: 1;
  border-color: rgba(0, 94, 220, var(--tw-border-opacity));
  border-style: solid;
  border-width: 2px;
}
.image-view .name {
  color: #000;
  font-size: 16px;
  padding-top: 20px;
}
</style>